import { CircularProgress } from "@mui/material"
import InfoRow from "./InfoRow"

export default function LoadingRow(props) {
    const { colSpan } = props
    return <InfoRow colSpan={colSpan}  >
        <CircularProgress size={30} color="inherit" />
    </InfoRow>
}